{
    "nm": "Main Scene",
    "ddd": 0,
    "h": 4,
    "w": 375,
    "meta": {
        "g": "@lottiefiles/creator 1.84.0"
    },
    "layers": [
        {
            "ty": 4,
            "nm": "Gradient",
            "sr": 1,
            "st": 0,
            "op": 150,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        3
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        53,
                        100
                    ]
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                -127,
                                5
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                -127,
                                5
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                557,
                                5
                            ],
                            "t": 60
                        }
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "shapes": [
                {
                    "ty": "rc",
                    "bm": 0,
                    "hd": false,
                    "nm": "Rectangle Path 1",
                    "d": 1,
                    "p": {
                        "a": 1,
                        "k": [
                            {
                                "o": {
                                    "x": 0,
                                    "y": 0
                                },
                                "i": {
                                    "x": 0.36,
                                    "y": 1
                                },
                                "s": [
                                    0,
                                    5
                                ],
                                "t": 0
                            },
                            {
                                "s": [
                                    0,
                                    0
                                ],
                                "t": 30
                            }
                        ]
                    },
                    "r": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            376,
                            5
                        ]
                    }
                },
                {
                    "ty": "gf",
                    "bm": 0,
                    "hd": false,
                    "nm": "Fill",
                    "e": {
                        "a": 0,
                        "k": [
                            186.23736400675182,
                            -0.2636328847684082
                        ]
                    },
                    "g": {
                        "p": 4,
                        "k": {
                            "a": 0,
                            "k": [
                                0.0049504950495049506,
                                0.7058823529411765,
                                0.9254901960784314,
                                0.8745098039215686,
                                0.3992496905940594,
                                0.9686274509803922,
                                0.9137254901960784,
                                0.6705882352941176,
                                0.6866878094059405,
                                0.9607843137254902,
                                0.7607843137254902,
                                0.796078431372549,
                                0.9851485148514851,
                                0.7058823529411765,
                                0.9254901960784314,
                                0.8745098039215686
                            ]
                        }
                    },
                    "t": 1,
                    "a": {
                        "a": 0,
                        "k": 0
                    },
                    "h": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            -188.5,
                            0
                        ]
                    },
                    "r": 2,
                    "o": {
                        "a": 0,
                        "k": 100
                    }
                }
            ],
            "ind": 1
        },
        {
            "ty": 4,
            "nm": "BG Rectangle",
            "sr": 1,
            "st": 0,
            "op": 150,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        3
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 0,
                    "k": [
                        187,
                        5
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "shapes": [
                {
                    "ty": "rc",
                    "bm": 0,
                    "hd": false,
                    "nm": "Rectangle Path 1",
                    "d": 1,
                    "p": {
                        "a": 1,
                        "k": [
                            {
                                "o": {
                                    "x": 0,
                                    "y": 0
                                },
                                "i": {
                                    "x": 0.36,
                                    "y": 1
                                },
                                "s": [
                                    0,
                                    -5
                                ],
                                "t": 0
                            },
                            {
                                "o": {
                                    "x": 0.22,
                                    "y": 0.61
                                },
                                "i": {
                                    "x": 1,
                                    "y": 1
                                },
                                "s": [
                                    0,
                                    0
                                ],
                                "t": 30
                            },
                            {
                                "o": {
                                    "x": 0.167,
                                    "y": 0.167
                                },
                                "i": {
                                    "x": 0.833,
                                    "y": 0.833
                                },
                                "s": [
                                    0,
                                    0
                                ],
                                "t": 60
                            },
                            {
                                "s": [
                                    0,
                                    -5
                                ],
                                "t": 90
                            }
                        ]
                    },
                    "r": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            376,
                            5
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "Fill",
                    "c": {
                        "a": 0,
                        "k": [
                            0.7176,
                            0.9333,
                            1
                        ]
                    },
                    "r": 2,
                    "o": {
                        "a": 0,
                        "k": 100
                    }
                }
            ],
            "ind": 2
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 150,
    "ip": 0,
    "assets": []
}